import {observable, computed, reaction} from "mobx";
import FluxoStore from "../../comum/stores/FluxoStore";
import moment from "moment/moment";
import {getByAtribute} from "../../../../utils/formatar";
import {getNomeFluxosById} from "../../../../utils/enums";
import _ from "lodash";

//TODO: extrair dados de FluxoStore que pertence apenas ao fluxo de solicitação de prorrogacao
export default class FluxoProrrogacaoStore extends FluxoStore {

    @observable solicitacaoProrrogacao;
    @observable momentDataFinalProrrogada;
    @observable dataFinalProrrogadaValidacao;
    @observable confirmacaoMTE;
    @observable isSolicitacaoProrrogacao;
    @observable loadingGestorArDebito;
    @observable isLoadingArDebito;
    @observable gestoresArDebito;
    @observable gestorARError;
    @observable justificativaInicial;
    @observable justificativaAlterada;
    @observable produtoSelecionado;
    @observable sistemaAlocacaoVigente;
    
    @observable targetCentroCustoDebito;
    @observable dadosOk;

    constructor(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore) {
        super(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore);

        this.filtrarProdutos = _.debounce(this._filtrarProdutosPorTermo, 1000);

        this.confirmacaoMTE = false;
        this.isSolicitacaoProrrogacao = true;
        this.loadingGestorArDebito = false;
        this.isLoadingArDebito = false;
        this.gestoresArDebito = [];
        this.gestorARError = [];
        this.justificativaAlterada = false;
        this.produtoSelecionado = undefined;
        this.sistemaAlocacaoVigente = "MOT";
        this.isLoadingProduto = false;
        this.produtos = [];

        this.dadosOk = true;

        this.resetSolicitacaoProrrogacao();

        reaction(
            () => this.solicitacao.gestorAreaDebito,
            gestorAr => {
                if(!gestorAr) {
                    this.gestorARError = [];
                }
            }
        );

    }

    @computed get idSolicitacaoExibicao() {
        const solicitacaoEttId = _.get(this.solicitacaoEtt,"idSolicitacaoEtt") ? "/"+ this.solicitacaoEtt.idSolicitacaoEtt : "";
        const solicitacaoProrrogacao =  _.get(this.solicitacaoProrrogacao,"idSolicitacao") ? this.solicitacaoProrrogacao.idSolicitacao : "";

        if (solicitacaoProrrogacao){
            return this.solicitacao.id + solicitacaoEttId +"/PR"+ solicitacaoProrrogacao;
        } else if (solicitacaoEttId){
            return this.solicitacao.id + solicitacaoEttId
        }
         else {
            return "Carregando...";
        }
    }

    @computed
    get quantidadeDiasProrrogacao() {
        return this.dataInicioProrrogacao && this.momentDataFinalProrrogada ? this.momentDataFinalProrrogada.diff(this.dataInicioProrrogacao, 'days') + 1 : 0;
    }

    @computed
    get dataInicioProrrogacao() {
        return this.solicitacao.momentDataTermino ?  moment(this.solicitacao.momentDataTermino).add(1, "days") : null;
    }

    @computed
    get dataFinalProrrogada() {
        return this.solicitacaoProrrogacao.dataFinalProrrogada ? moment(this.solicitacaoProrrogacao.dataFinalProrrogada) : null;
    }

    @computed
    get quantidadeDiasProrrogacaoRegulamentada() {
        const diasContratoTotal = this.quantidadeDias + this.quantidadeDiasProrrogacao;
        if(_.get(this.parametrosGeraisStore, "parametros")) {
            if(diasContratoTotal >= 10 && diasContratoTotal <= 160) {
                return this.parametrosGeraisStore.parametros.pmrifProrrogUmRgl;
            } else if(diasContratoTotal >= 161 && diasContratoTotal <= 180) {
                return this.parametrosGeraisStore.parametros.pmrifProrrogDoisRgl;
            } else if(diasContratoTotal >= 181) {
                return this.parametrosGeraisStore.parametros.pmrifProrrogTresRgl;
            }
        }
        return 0;
    }

    @computed
    get msgValidacaoJustificativaProrrogacao() {
        const justificativa = this.solicitacao.justificativaContratacao;
        if(justificativa) {
            const anteProrrogacaoDiasMin        = justificativa.anteProrrogacaoDiasMin ? justificativa.anteProrrogacaoDiasMin : 0;
            const contRenovDiasMax              = justificativa.contRenovDiasMax;
            const solicContratacaoDiasMax       = justificativa.solicContratacaoDiasMax;
            const prorrogacaoDiasMin            = justificativa.prorrogacaoDiasMin ? justificativa.prorrogacaoDiasMin : 0;
            const now                           = moment().startOf('day');
            const dataInicio                    = moment(this.solicitacao.dataInicio, "DD/MM/YYYY");
            const qtd_dias                      = dataInicio.isAfter(now) ? 0 : now.diff(dataInicio, "days") + 1;

            const naoPodeProrrogar = ((solicContratacaoDiasMax && qtd_dias > (solicContratacaoDiasMax - anteProrrogacaoDiasMin) && qtd_dias <= solicContratacaoDiasMax) || (contRenovDiasMax && this.quantidadeDias > (contRenovDiasMax - prorrogacaoDiasMin)));

            if(naoPodeProrrogar) {
                return "A justificativa selecionada não permite prorrogação deste contrato";
            }
        }

        return ""
    }

    @computed
    get dataProrrogacaoMin() {
        const diasContratoTotal = this.quantidadeDias + this.quantidadeDiasProrrogacao;
        let prorrogacaoMinimaParametrosGerais = 0;
        if(_.get(this.parametrosGeraisStore, "parametros")) {
            if(diasContratoTotal >= 10 && diasContratoTotal <= 160) {
                prorrogacaoMinimaParametrosGerais = this.parametrosGeraisStore.parametros.pmrifProrrogUmMin;
            } else if(diasContratoTotal >= 161 && diasContratoTotal <= 180) {
                prorrogacaoMinimaParametrosGerais = this.parametrosGeraisStore.parametros.pmrifProrrogDoisMin;
            } else if(diasContratoTotal >= 181) {
                prorrogacaoMinimaParametrosGerais = this.parametrosGeraisStore.parametros.pmrifProrrogTresMin;
            }
        }

        let inicioMinProrrogacao = 0;
        if(this.solicitacao.justificativaContratacao && this.solicitacao.justificativaContratacao.prorrogacaoDiasMin) {
            if(prorrogacaoMinimaParametrosGerais > this.solicitacao.justificativaContratacao.prorrogacaoDiasMin) {
                inicioMinProrrogacao = prorrogacaoMinimaParametrosGerais;
            } else {
                inicioMinProrrogacao = this.solicitacao.justificativaContratacao.prorrogacaoDiasMin
            }
        } else {
            inicioMinProrrogacao = prorrogacaoMinimaParametrosGerais;
        }

        return moment(this.solicitacao.momentDataTermino).add(inicioMinProrrogacao, "days")
    }

    @computed
    get exibeConfirmacaoMTE() {
        return this.modalStore.exibirModal.tipo === 'aprovar' && this.isFluxoProrrogacao && this.isTarefaHTAvaliacaoSolicitacaoEtt;
    }

    @computed
    get dataProrrogacaoMax() {
        if(this.solicitacao.justificativaContratacao && this.solicitacao.justificativaContratacao.prorrogacaoDiasMax) {
            let prorrogacaoDiasMax;
            if(this.quantidadeDias+this.solicitacao.justificativaContratacao.prorrogacaoDiasMax>this.solicitacao.justificativaContratacao.contRenovDiasMax)
                prorrogacaoDiasMax = this.solicitacao.justificativaContratacao.contRenovDiasMax - this.quantidadeDias;
            else
                prorrogacaoDiasMax = this.solicitacao.justificativaContratacao.prorrogacaoDiasMax;

            return moment(this.solicitacao.momentDataTermino).add(prorrogacaoDiasMax, "days");
        } else {
            return null;
        }
    }

    @computed
    get isSolicitadoPeloGestor() {
        const { usuarioLogado } = this.loginStore;
        const { gestorSolicitante } = this.solicitacao;

        return this.modalStore.exibirModal.tipo === 'prorrogar'
            && usuarioLogado.matricula === gestorSolicitante.matricula;
    }

    @computed
    get isGestorAreaDebitoSelecionado() {
        return this.solicitacao.gestorAreaDebito && this.solicitacao.gestorAreaDebito.matricula;
    }

    @computed
    get exibeAprovadoresExtraDetalhamento() {
        return this.isSolicitadoPeloGestor || (this.modalStore.exibirModal.tipo === "aprovar" && this.isTarefaHTAvaliacaoSolicitacao)
    }

    @computed
    get exibirDescricaoSolicitacaoCentroCustoDebito() {
        if (this.solicitacao.centroCustoDebito && _.get(this.solicitacao.gestorAreaDebito, "nomeArea")) {
            return this.solicitacao.centroCustoDebito + ' ' + this.solicitacao.gestorAreaDebito.nomeArea;
        } else if (this.solicitacao.centroCustoDebito) {
            return this.solicitacao.centroCustoDebito
        } else {
            return "";
        }
    }
    @computed
    get isCentroCustoDebitoMediaPulse() {
        return (this.targetCentroCustoDebito && this.targetCentroCustoDebito == "MEDIAPULSE");
    }

    @computed
    get isJustificativaCusteioDireto() {
        let justificativa = this.solicitacao.justificativaContratacao;
        let produtoOracle = justificativa ? justificativa.produtoOracle : null;

        return produtoOracle;
    }

    @computed
    get mensagemAlertaAlocacao() {

        let centroCustoDebito = this.solicitacao.centroCustoDebito;
        let codProduto = this.solicitacao.produto.codigo;
        let chaveContabil = centroCustoDebito + "-" + codProduto;
        let mensagem = null;

        let mensagemCusteioDireto = "Caso queira custear pelo projeto escolhido no SGTMOT, selecione uma justificativa 'Exclusiva p/ custeio direto'. "
        let mensagemCentroCusto = `O custeio mensal será realizado na chave contábil ${chaveContabil}.`


        if (this.isCentroCustoDebitoMediaPulse) {
            mensagem = isJustificativaCusteioDireto ? mensagemCentroCusto : mensagemCusteioDireto;
        } else {

        }

        return mensagem;
    }

    @computed
    get mensagemCentroCustoDebitoMediapulse() {
        let mensagem = "Este centro de custo segue regras de planejamento/alocação de recursos. Caso queira definir o custeio pelo SGTMOT, selecione uma justificativa 'Exclusiva p/ custeio direto'."
        return this.isCentroCustoDebitoMediaPulse ? mensagem : "";
    }

    @computed
    get isProdutoEditavel() {
        let mediaPulse = (this.targetCentroCustoDebito && this.targetCentroCustoDebito == "MEDIAPULSE");
        let editavel = (this.solicitacao.justificativaContratacao &&
            _.get(this.solicitacao, "justificativaContratacao.justificativaAlocavel") !== "NAO" &&
            !(!this.solicitacao.justificativaContratacao.produtoOracle && mediaPulse));
        return editavel;
    }

    @computed
    get exibeEvolucaoFluxo(){
        return (this.evolucaoFluxo !== undefined && this.evolucaoFluxo.length > 0);
    }

    @computed
    get isAjuste(){
        return this.isTarefaHTAjusteSolicitacao;
    }

    resetSolicitacaoProrrogacao = () => {
        this.solicitacaoProrrogacao = {
            dataFinalProrrogada: null,
            gestorAreaDebito: null,
            justificativa: null,
            codigoArDebito: null,
            idJustificativa: null,
            idProduto: null
        }
    };

    //override
    carregarDadosExtras = (response, carregandoDadosPor, dadosUrl) => {
        if (carregandoDadosPor === "taskId" || carregandoDadosPor === "andamentoProrrogacao") {
            this.solicitacaoProrrogacao = response.solicitacaoProrrogacao;
            this.solicitacaoProrrogacao.dataFinalProrrogada = response.solicitacaoProrrogacao.dataTerminoSolicitacao;
            this.momentDataFinalProrrogada = moment(this.solicitacaoProrrogacao.dataFinalProrrogada);
            this.dataFinalProrrogadaValidacao = moment(this.momentDataFinalProrrogada).format("DD/MM/YYYY");
            this.justificativaInicial = JSON.parse(JSON.stringify(this.solicitacao.justificativaContratacao));
            this.carregarDadosDeProrrogacaoNaSolicitacao();
            this.sistemaAlocacaoVigente = _.get(response.solicitacaoProrrogacao, "produto.sistemaAlocacao") ? response.solicitacaoProrrogacao.produto.sistemaAlocacao : "MOT";
        } else {
            this.justificativaInicial = JSON.parse(JSON.stringify(this.solicitacao.justificativaContratacao));
            this.sistemaAlocacaoVigente = this.produtoVigente && this.produtoVigente.sistemaAlocacao ? this.produtoVigente.sistemaAlocacao : "MOT";
        }

        if(this.isSolicitacaoProrrogacao) {
            if(this.nomeTarefa !== "HT_AjusteSolicitacao") {
//                this.setDataProrrogacao(null);
            }
            //this.carregarGestoresArDebito();
        }


        this.carregarJustificativasPeloMotivoInicial();

        if (this.solicitacao.produto !== undefined && this.solicitacao.produto !== null){
            this.solicitacao.produto.label = this.solicitacao.produto.nome + " (" + this.solicitacao.produto.codigo + ")";
        }
        this.produtoSelecionado = this.solicitacao.produto;
        this.carregarGestoresArDebito();
        this.isLoadingProduto = false;
    };

    carregarDadosDeProrrogacaoNaSolicitacao = () => {
        this.solicitacao.centroCustoDebito = this.solicitacaoProrrogacao.centroCustoDebito;
        this.solicitacao.gestorAreaDebito = this.solicitacaoProrrogacao.gestorAreaDebito;
        this.solicitacao.justificativaContratacao = this.solicitacaoProrrogacao.justificativaContratacao;
        this.solicitacao.justificativaContratacaoId = this.solicitacaoProrrogacao.justificativaContratacao.id;
        this.solicitacao.detalhamentoJustificativa = this.solicitacaoProrrogacao.detalhamentoJustificativa;
        this.solicitacao.produto = this.solicitacaoProrrogacao.produto;
    };

    toggleConfirmacaoModalMTE = () => {
        this.confirmacaoMTE = !this.confirmacaoMTE;
    };

    setDataProrrogacao = (value) => {
        let date = value;
        if(date) {
            date = moment(date.format('DD/MM/YYYY'), "DD/MM/YYYY");

            this.momentDataFinalProrrogada = date;
            this.solicitacaoProrrogacao.dataFinalProrrogada = date.toJSON();
            this.dataFinalProrrogadaValidacao =  date.format('DD/MM/YYYY');
        } else {
            this.momentDataFinalProrrogada = null;
            this.solicitacaoProrrogacao.dataFinalProrrogada = null;
            this.dataFinalProrrogadaValidacao =  null;
        }
    };

    setDataProrrogacaoCheck = (value) => {
        this.dataFinalProrrogadaValidacao = value;
        if(!value) {
            this.solicitacaoProrrogacao.dataFinalProrrogada = "";
            this.dataFinalProrrogadaValidacao = null;
        }
    };

    setJustificativaContratacao(value) {
        this.solicitacao.justificativaContratacaoId = value;
        this.solicitacao.justificativaContratacao = getByAtribute(this.justificativasContratacao, value, "id");

        this.justificativaAlterada = true;

        this.resetProduto();

    }

    resetProduto() {
        this.solicitacao.produtoId = "";
        this.solicitacao.produto = null;
        this.produtoSelecionado = undefined;
    }

    setProduto(value, options) {
        if (value == "" || value == null) {
            this.resetProduto();
        }
        else {
            this.solicitacao.produtoId = value;
            this.solicitacao.produto = options[0];
            this.produtoSelecionado = this.solicitacao.produto;
        }
    }

    setDetalhamentoJustificativa(value) {
        this.solicitacao.detalhamentoJustificativa = value;
    }

    getDadosProrrogacao() {
        return {
            dataFinalProrrogada: this.solicitacaoProrrogacao.dataFinalProrrogada,
            dataInicialProrrogada: this.dataInicioProrrogacao,
            justificativa: this.solicitacao.detalhamentoJustificativa,
            gestorAreaDebito: this.solicitacao.gestorAreaDebito,
            centroCustoDebito: this.solicitacao.centroCustoDebito,
            idJustificativa: this.solicitacao.justificativaContratacaoId,
            idProduto: this.solicitacao.produtoId,
            solicitacaoEttId: this.idSolicitacao,
            aprovadoresExtra: this.apenasMatriculaAprovadoresExtraValidos,
            observacao: this.observacoes
        }
    }

    atualizarDadosProrrogacaoInDetalhesTarefa = () => {
        this.detalhesTarefa.solicitacaoProrrogacao.detalhamentoJustificativa =  this.solicitacao.detalhamentoJustificativa;
        this.detalhesTarefa.solicitacaoProrrogacao.usuarioSolicitante = this.solicitacao.usuarioSolicitante;
        this.detalhesTarefa.solicitacaoProrrogacao.dataTerminoSolicitacao = this.solicitacaoProrrogacao.dataFinalProrrogada;
        this.detalhesTarefa.solicitacaoProrrogacao.justificativaContratacao = this.solicitacao.justificativaContratacao;
        this.detalhesTarefa.solicitacaoProrrogacao.produto = this.solicitacao.produto && this.solicitacao.produto.id ? this.solicitacao.produto : null;
        this.detalhesTarefa.solicitacaoProrrogacao.gestorAreaDebito = this.solicitacao.gestorAreaDebito;
        this.detalhesTarefa.solicitacaoProrrogacao.centroCustoDebito = this.solicitacao.centroCustoDebito;
    };

    carregarGestoresArDebito = () => {
        //TODO: refatorar
        this.gestoresArDebito = [];
        this.targetCentroCustoDebito = "MOT";
        if(this.solicitacao.centroCustoDebito && this.solicitacao.localContratacaoId) {
            this.isLoadingArDebito = true;
            this.areaService.getGestorByCodigoArDebitoEEmpresaGloboId(this.solicitacao.centroCustoDebito, this.solicitacao.localContratacaoId).then(response => {
                if(!!response.data) {
                    this.targetCentroCustoDebito = response.data.target;
                    this.gestoresArDebito = response.data.gestores;
                    const idAprovador = _.get(this.solicitacao, "gestorAreaDebito.idAprovador");
                    if(idAprovador) {
                        if(!getByAtribute(this.gestoresArDebito, idAprovador, "idAprovador")) {
                            this.solicitacao.gestorAreaDebito = null;
                        }
                    }
                } else {
                    this.gestoresArDebito = [];
                    this.solicitacao.centroCustoDebito = null;
                    this.solicitacao.gestorAreaDebito = null;
                }
                this.isLoadingArDebito = false;
            }).catch(error => {
                console.log(error)
                this.isLoadingArDebito = false;
                this.gestoresArDebito = [];
                this.solicitacao.gestorAreaDebito = null;
                this.solicitacao.centroCustoDebito = null;
            })
        } else {
            this.gestoresArDebito = [];
            this.solicitacao.gestorAreaDebito = null;
            this.solicitacao.centroCustoDebito = null;
        }
    };

    setGestorAreaDebito(value, options) {
        this.solicitacao.gestorAreaDebito = null;
        if(options && options.length > 0) {
            //response.data.idAprovador = options[0].idAprovador;
            this.solicitacao.gestorAreaDebito = options[0];
        }
    }

    filtrarAreaDebito(input, callback) {
        const result = [];
        if (input && input.length === 11) {
            // transformar o valor digitado em caixa alta para resolver erro em lotes de pagto 
            input = input.toUpperCase();
            this.areaService.getGestorByCodigoArDebitoEEmpresaGloboId(input, this.solicitacao.localContratacaoId).then(response => {
                if (!!response.data) {
                    result.push({value: input, label: input});
                }
                callback(null, {
                    options: result,
                    complete: false
                });
            }).catch(error => {
                callback(null, {
                    options: result,
                    complete: false
                });
                console.log(error);
            });
        } else {
            callback(null, {
                options: result,
                complete: false
            });
        }
    }

    getIdAprovadorGestorArDebito() {
        if(this.solicitacao.gestorAreaDebito && this.solicitacao.gestorAreaDebito.matricula) {
            const gestor = this.solicitacao.gestorAreaDebito;
            const matricula = this.solicitacao.gestorAreaDebito.matricula;
            this.loadingGestorArDebito = true;
            this.solicitacao.gestorAreaDebito = null;
            this.gestorARError = [];
            this.empregadoService.getEbsByMatricula(matricula).then(response => {
                if(response.data && getByAtribute(this.gestoresArDebito, response.data.idAprovador, "idAprovador")) {
                    gestor.idAprovador = response.data.idAprovador;
                    gestor.nome = response.data.nome;
                    this.solicitacao.gestorAreaDebito = gestor;
                }
                this.loadingGestorArDebito = false;
            }).catch(error => {
                this.gestorARError = _.get(error, "response.data.message") ? [_.get(error, "response.data.message")] : [];
                this.loadingGestorArDebito = false;
            })
        }
    }

    setCentroCustoDebito(value) {
        this.solicitacao.centroCustoDebito = value;
        this.carregarGestoresArDebito(); 
    }

    handleDetalhesTarefaByTaskId = (detalhesTarefa) => {
        this.idFluxo = detalhesTarefa.idFluxo;

        this.detalhesTarefa = detalhesTarefa;
        this.detalhesTarefa.solicitacao.motivoContratacao = this.detalhesTarefa.solicitacao.justificativaContratacao.motivoContratacao;
        this.setDataMomentInDetalhesTarefa();
        this.checkAprovadoresExtraInDetalhesTarefa();
        this.setSolicitacaoFromDetalhesTarefa();
        this.setPossiveisAcoesFromDetalhesTarefa();
        this.setNomeFluxoETarefaFromDetalhesTarefa();
        this.tituloPaginaStore.setTitulo(getNomeFluxosById(detalhesTarefa.nomeFluxo).valor + " - "+detalhesTarefa.nomeTarefa);
        this.idInstanciaFluxo = detalhesTarefa.idInstanciaFluxo;
        this.idSolicitacao = detalhesTarefa.solicitacaoEtt ? detalhesTarefa.solicitacaoEtt.idSolicitacaoEtt : this.solicitacao.id;
        this.getComentarios();
        this.getTarefasFluxo();
        this.setSolicitacaoEtt(this.detalhesTarefa.solicitacaoEtt);
        this.setSolicitacaoMudancaPrazoFromDetalhesTarefa();
        this.atualizaPropriedadesDerivadasDeCargoEEmpresaGlobo(this.solicitacao.id);

        if (this.isAjuste){
            this.carregarJustificativasPeloMotivoInicial();
            //this.carregarProdutosPelaJustificativaInicial();
        }
    }

    handleSolicitacaoEttById = (solicitacaoEtt, setTitulo, idSolicitacaoMudancaPrazo) => {
        this.setSolicitacaoEtt(solicitacaoEtt);
        if(setTitulo) {
            this.tituloPaginaStore.setTitulo("Detalhamento de contratação");
        }
        this.idSolicitacao = solicitacaoEtt.idSolicitacaoEtt;
        this.solicitacaoMudancaPrazo.solicitacaoEttId = this.idSolicitacao;
        this.solicitacaoMudancaPrazo.id = idSolicitacaoMudancaPrazo;
        this.getComentarios();
        this.getTarefasFluxo();
    };

    getTarefasFluxo(){
        if (this.idFluxo !== undefined){
            this.fluxoService.getEvolucaoFluxo(this.idFluxo).then(response => {
                //tratamento para não quebrar o detalhamento da prorrogação e término antecipado
                if(response && response.data && Array.isArray(response.data)) {
                    this.evolucaoFluxo = response.data;
                }
            }).catch(error => {
                console.log(error);
            });
        }
    }

    carregarDados(tipoDetalhamento, setTitulo) {

        let promise = null;
        let carregandoDadosPor = null;

        this.carregarDadosBasicosUrl(tipoDetalhamento);
        
        if (tipoDetalhamento.tipo === "tarefa") {
            carregandoDadosPor = "taskId";
            promise = this.fluxoService.getProrrogacaoContrato(tipoDetalhamento.id);
        } else if (tipoDetalhamento.tipo === "solicitacao" && tipoDetalhamento.solicitacaoEttId) {
            carregandoDadosPor = "solicitacaoEttId";
            promise = this.fluxoService.carregarDetalhesSolicitacaoByEttId(tipoDetalhamento.solicitacaoEttId);
        }

        // Se nenhuma condição for atendida, a promise será nula e nada deve ser executado.
        if (!promise) {
            this.dadosOk = false;
            return;
        }

        this.loadingPanelStore.setIsLoading("FluxoLoading", true);
        this.preCarregarDadosExtra(tipoDetalhamento);

        promise.then(response => {
            this.idFluxo = response.data.idFluxo;
            this.dadosOk = true;
            switch (carregandoDadosPor) {
                case "taskId":
                    this.handleDetalhesTarefaByTaskId(response.data);
                    this.handleTempoVigenciaContrato(response.data.tempoVigenciaContrato);
                    break;
                case "solicitacaoEttId":
                    this.handleSolicitacaoPorId(response.data.solicitacao, !!tipoDetalhamento.solicitacaoEttId, setTitulo);
                    this.handleSolicitacaoEttById(response.data.solicitacaoEtt, setTitulo, tipoDetalhamento.prorrogacaoId);
                    this.handleTempoVigenciaContrato(response.data.tempoVigenciaContrato);
                    break;
            }

            this.carregarDadosProrrogacoesAnteriores();
            this.carregarDadosMigracoesRealizadas();
            this.carregarDadosExtras(response.data, carregandoDadosPor, tipoDetalhamento);
            this.quantidadeDiasInicial = this.quantidadeDias;
        }).catch(error => {
            this.dadosOk = false;
            console.error("Falha ao carregar dados de prorrogação:", error);
        }).finally(() => {
            this.loadingPanelStore.setIsLoading("FluxoLoading", false);
        });

    }

    // transforma dados da gestor de debito. Relativo ao EmpregadoDTO do backend
    transformarGestorAreaDebito(){
        return {
            id: this.solicitacao.gestorAreaDebito.id,
            matricula: this.solicitacao.gestorAreaDebito.matricula,
            login: this.solicitacao.gestorAreaDebito.login,
            email: this.solicitacao.gestorAreaDebito.email
        }
    }
    // Monta o dto com dados da prorrogacao. Relativo ao SolicitacaoMudancaPrazoDTO do backend
    montarDadosProrrogacao() {
        return {
            id: this.solicitacaoProrrogacao.idSolicitacao,
            tipo: "PRO",
            justificativaContratacaoId: this.solicitacao.justificativaContratacaoId,
            detalhamentoJustificativa: this.solicitacao.detalhamentoJustificativa,
            produtoId: this.solicitacao.produtoId,
            dataInicioProrrogacao: this.dataInicioProrrogacao,
            dataTerminoProrrogada: this.solicitacaoProrrogacao.dataFinalProrrogada,
            centroCustoDebito: this.solicitacao.centroCustoDebito,
            gestorAreaDebito: this.transformarGestorAreaDebito(),
            observacao: this.observacoes
        }
    }

    // monta o dto de tramite. Relativo ao TramiteFluxoDTO do backend
    montarTramiteFluxo(idTask, acao){
        var tramite = {
            idTask: idTask,
            acao: acao,
            nomeFluxo: this.nomeFluxo,
            tipoFluxo: "solicitacaoProrrogacao",
            tipoTarefa: this.detalhesTarefa ? this.detalhesTarefa.definicaoTarefaId : "",
            idSolicitacao: this.solicitacaoEtt.idSolicitacao,
            idSolicitacaoEtt: this.solicitacaoEtt.idSolicitacaoEtt,
            comentario: this.observacoes, 
            aprovadoresExtra: this.apenasMatriculaAprovadoresExtraValidos,
            dadosProrrogacao: this.montarDadosProrrogacao()
        }
        return tramite
    }

    // metodos de ação do fluxo
    prorrogar(id) { // envio da prorrogacao
        if(this.isContratacaoVigenteOuConcluida) {
            var tramite = this.montarTramiteFluxo(id, "ENVIAR");
            return  this.fluxoService.prorrogar(tramite);
        } else {
            this.atualizarDadosProrrogacaoInDetalhesTarefa();
            return this.enviar(id)
        }
    }

    demandarAjustes(id) { // alguem demandou ajuste na tarefa
        if (id) {
            var tramite = this.montarTramiteFluxo(id, "AJUSTE");
            return this.fluxoService.tramitarFluxo(tramite);
        }
    }

    rejeitar(id) { // tarefa cancelada ou rejeitada
        this.validacaoStore.desabilitarValidacao = false;
        if (id) {
            return this.fluxoService.tramitarFluxo(this.montarTramiteFluxo(id, "REJECT"));
        }
    }

    aprovar(id) { // tarefa aprovada
        if (id) {
            var tramite = this.montarTramiteFluxo(id, "APPROVE");
            return this.fluxoService.tramitarFluxo(tramite);
        }
    }

    enviar(id) { // envio do ajuste feito pelo usuario solicitante
        var tramite = this.montarTramiteFluxo(id, "ENVIAR");
        return  this.fluxoService.tramitarFluxo(tramite);
    }

    cancelar(id) {
        this.validacaoStore.desabilitarValidacao = false;
        if (id) {
            return  this.fluxoService.tramitarFluxo(this.montarTramiteFluxo(id, "CANCELAR"));        
        }
    }
}